import { render, staticRenderFns } from "./CallWaiter.vue?vue&type=template&id=7185f6ce&scoped=true&"
import script from "./CallWaiter.vue?vue&type=script&setup=true&lang=js&"
export * from "./CallWaiter.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./CallWaiter.vue?vue&type=style&index=0&id=7185f6ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7185f6ce",
  null
  
)

export default component.exports
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import qInstall from "../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QDialog});
